module.exports = __webpack_public_path__ + "img/fb-truck.0a64b8e2.svg";